import ActionTypes from '../constants/action-types';

export const setOtherUserProfile = (payload) => ({
    type: ActionTypes.SET_PROFILE,
    payload
});

export const resetOtherUserProfile = (payload) => ({
    type: ActionTypes.SET_PROFILE,
    payload: {}
});
